const style = {
  wrapper: {
    marginTop: `15px`
  },
  icon: {
    marginRight: `5px`,
    display: `inline-block`,
    width: `14px`
  },
  link: {
    color: `#777779`,
    fontSize: `12px`,
    display: `block`,
    width: `100%`,
    padding: `5px 15px`,
    textDecoration: `none`,
    ':hover': {
      color: `white`,
      background: `#303030`
    }
  },
  activeLink: {
    background: `#f7f7f7`,
    ':hover': {
      background: `#f7f7f7`,
      color: `#777779`
    }
  }
}

export default style



// WEBPACK FOOTER //
// ./src/components/Settings/Motd/partials/FileSystem/style/navigation.js